
<div class="error-message-container">
    <app-error-message  *ngIf="message!=''" [message]="message"></app-error-message>
</div>
<h2>כניסה ליישומים מזוהים</h2>

<!-- <ng-template> -->
    <div class="verification-code">
        <p *ngIf="!restartcode" style="margin-bottom: 5px;">
            שלחנו לך קוד אימות חד פעמי למספר:
            <span class="phone-number">{{phone}}</span>
        </p>
        <p *ngIf="restartcode" style="margin-bottom: 5px;">
            <img src="./assets/icons/success-status.svg" alt="אייקון הצלחה" style="height: 20px; vertical-align:sub; margin-left: 2px;">
             שלחנו לך קוד אימות <span style="font-weight: 600; margin: 0 3px;">חדש</span> למספר:
            <span class="phone-number">{{phone}}</span>
        </p>
  <!-- <div class="limited-time">
        <div (click)="openLinkInEdge()" class="update-phone">
זה לא המספר שלי </div>
<div class="tooltip-help"><span class="tooltiptext">ניתן לגשת לשירות זה<br> רק מתוך הרשת המשרדית</span></div></div> -->
        <form  [formGroup]="verificationCodeForm" id="verificationCodeForm">
            <div class="inputs-button-wrapper">
                <label for="otpMoe" class="eds-input-label">קוד האימות שקיבלת</label>
                <div class='inputs-container'>
                    <div>
                            <input id="otpMoe" formControlName="verificationCode" autofocus type="password" pInputText appOnlynumber togglePassword (input) = "message!='' && resetMassage()"
                            [ngClass]="{inputInvalid:isValidFormSubmitted && verificationCode.errors?.required }">
                            <!-- <p-message
                            severity="error"
                            text="קוד האימות קצר מידי"
                            *ngIf="(verificationCode.errors?.minlength && verificationCode.touched)"
                        ></p-message> -->
                        <p-message
                        severity="error"
                        text="שדה חובה"
                        *ngIf="isValidFormSubmitted && verificationCode.errors?.required"
                    ></p-message>
                    </div>
                </div>
                <div class="limited-time">
                    <img src="./assets/images/timer.png" alt="">
                    <span>קוד האימות מוגבל בזמן</span>
                </div>
                <div>
                    <div class="container-button-login container-fluid">
                        <p-button type="submit" class="btn-moe"
                            label="כניסה" (onClick)="CaptchaNeeded ? captchaRef.execute() : checkVerificationCode()">
                        </p-button>
                    </div>
                </div>
                <div class="back-button"><button class="link-button2" (click) ="back()">חזרה</button></div> 
            </div>
            <re-captcha #captchaRef="reCaptcha" (resolved)="$event && checkVerificationCode($event)" siteKey="{{this.sitekey}}" size="invisible" ></re-captcha> 
        </form>
    </div>
    <app-loader *ngIf="loader"  [text]="'המערכת בודקת את הנתונים'"></app-loader>




